<template>
  <div class="field-wrapper">
    <VField :label="$t('app.campaign.newPage.campaignName')" :placeholder="$t('app.campaign.newPage.campaignNamePlaceholder')" name="name" v-model="model" :required="true" />
  </div>
</template>

<style lang="scss" scoped>
.field-wrapper {
  width: 100%;
}
</style>

<script setup lang="ts">
import VField from '@/components/global/VField.vue';
import { CampaignCreation } from '@/stores/campaign';

const props = defineProps<{
  modelValue: CampaignCreation,
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: CampaignCreation): void
  (e: 'valid', value: boolean): void
}>();

const model = computed({
  get: () => props.modelValue.campaign.internal_name,
  set: (value: string) => {
    props.modelValue.campaign.internal_name = value;
    props.modelValue.campaign.headline = value;
    if (value.trim().length) {
      emit('valid', true);
    } else {
      emit('valid', false);
    }
    emit('update:modelValue', props.modelValue);
  }
});

</script>